import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ProfileMediaPreferences from './profile-media-preferences-model'
import {
  CreateProfileMediaPreferencesAsync,
  DeleteProfileMediaPreferencesAsync,
  LoadProfileMediaPreferencessAsync,
} from './profileMediaPreferences-thunk'
const initialState: profileMediaPreferencesSliceState = {
  profileMediaPreferences: [],
  selected_profileMediaPreferences: '',
  is_loading_profileMediaPreferences: false,
  is_creating_profileMediaPreferences: false,
  is_deleting_profileMediaPreferences: false,
}
export interface profileMediaPreferencesSliceState {
  profileMediaPreferences: ProfileMediaPreferences[]
  selected_profileMediaPreferences?: string
  is_loading_profileMediaPreferences: boolean
  is_creating_profileMediaPreferences: boolean
  is_deleting_profileMediaPreferences: boolean
}
export const profileMediaPreferencesSlice = createSlice({
  name: 'profileMediaPreferences',
  initialState,
  reducers: {
    setSelectedprofileMediaPreferences: (state, action) => {
      state.selected_profileMediaPreferences = action.payload
    },
    clearStateprofileMediaPreferences: (state) => {
      state.profileMediaPreferences = []
      state.is_loading_profileMediaPreferences = false
      state.is_creating_profileMediaPreferences = false
      state.is_deleting_profileMediaPreferences = false
    },
    mergeprofileMediaPreferences: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_profileMediaPreferences = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.profileMediaPreferences = merge(
            state.profileMediaPreferences,
            payload,
          ) as any
        }
      }
    },

    add_profileMediaPreferences: (state, action) => {
      if (action.payload) {
        state.profileMediaPreferences = [
          ...state.profileMediaPreferences,
          action.payload,
        ]
      }
    },
    set_profileMediaPreferences: (state, action) => {
      let { key, value, id } = action.payload
      state.profileMediaPreferences = state.profileMediaPreferences.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProfileMediaPreferencessAsync.pending, (state) => {
      state.is_loading_profileMediaPreferences = true
    })
    builder.addCase(
      LoadProfileMediaPreferencessAsync.fulfilled,
      (state, action) => {
        state.is_loading_profileMediaPreferences = false
        if (action.payload) {
          state.profileMediaPreferences = action.payload
        }
      },
    )
    builder.addCase(LoadProfileMediaPreferencessAsync.rejected, (state) => {
      state.is_loading_profileMediaPreferences = false
    })
    builder.addCase(CreateProfileMediaPreferencesAsync.pending, (state) => {
      state.is_creating_profileMediaPreferences = true
    })
    builder.addCase(CreateProfileMediaPreferencesAsync.fulfilled, (state) => {
      state.is_creating_profileMediaPreferences = false
    })
    builder.addCase(CreateProfileMediaPreferencesAsync.rejected, (state) => {
      state.is_creating_profileMediaPreferences = false
    })
    builder.addCase(DeleteProfileMediaPreferencesAsync.pending, (state) => {
      state.is_deleting_profileMediaPreferences = true
    })
    builder.addCase(
      DeleteProfileMediaPreferencesAsync.fulfilled,
      (state, action) => {
        state.is_deleting_profileMediaPreferences = false
        if (state.profileMediaPreferences) {
          state.profileMediaPreferences = state.profileMediaPreferences.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteProfileMediaPreferencesAsync.rejected, (state) => {
      state.is_deleting_profileMediaPreferences = false
    })
  },
})

export const {
  clearStateprofileMediaPreferences,
  setSelectedprofileMediaPreferences,
  set_profileMediaPreferences,
  mergeprofileMediaPreferences,
  add_profileMediaPreferences,
} = profileMediaPreferencesSlice.actions

export const get_profileMediaPreferences =
  (id?: string) =>
  (state: {
    profileMediaPreferences: {
      profileMediaPreferences: ProfileMediaPreferences[]
    }
  }): ProfileMediaPreferences | null => {
    let temp = state?.profileMediaPreferences?.profileMediaPreferences?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.profileMediaPreferences?.profileMediaPreferences[0] || null
  }
export const get_selected_profileMediaPreferences = (state: {
  profileMediaPreferences: profileMediaPreferencesSliceState
}): ProfileMediaPreferences | null => {
  let id = state?.profileMediaPreferences?.selected_profileMediaPreferences
  let temp = state?.profileMediaPreferences?.profileMediaPreferences?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_profileMediaPreferences = (state: {
  profileMediaPreferences: {
    profileMediaPreferences: ProfileMediaPreferences[]
  }
}): ProfileMediaPreferences[] => {
  let temp = state?.profileMediaPreferences?.profileMediaPreferences
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_profileMediaPreferences_busy = (state: {
  profileMediaPreferences: profileMediaPreferencesSliceState
}) => {
  return (
    state?.profileMediaPreferences.is_deleting_profileMediaPreferences ||
    state?.profileMediaPreferences.is_loading_profileMediaPreferences ||
    state?.profileMediaPreferences.is_creating_profileMediaPreferences
  )
}
export const is_deleting_profileMediaPreferences_busy = (state: {
  profileMediaPreferences: profileMediaPreferencesSliceState
}) => {
  return state?.profileMediaPreferences.is_deleting_profileMediaPreferences
}
export const is_loading_profileMediaPreferences_busy = (state: {
  profileMediaPreferences: profileMediaPreferencesSliceState
}) => {
  return state?.profileMediaPreferences.is_loading_profileMediaPreferences
}
export const is_creating_profileMediaPreferences_busy = (state: {
  profileMediaPreferences: profileMediaPreferencesSliceState
}) => {
  return state?.profileMediaPreferences.is_creating_profileMediaPreferences
}

export default profileMediaPreferencesSlice.reducer
